// Iter v34cg — Custom hook to load default company brand (name + logo URL).
// Public endpoint /api/public/brand + /api/public/brand/logo. No auth.
import { useEffect, useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export default function useBrand() {
  const [brand, setBrand] = useState({ name: "", hasLogo: false, logoUrl: null, loaded: false });

  useEffect(() => {
    let cancelled = false;
    fetch(`${BACKEND}/api/public/brand`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : { name: "", has_logo: false }))
      .then((d) => {
        if (cancelled) return;
        setBrand({
          name: d.name || "",
          hasLogo: !!d.has_logo,
          logoUrl: d.has_logo ? `${BACKEND}/api/public/brand/logo` : null,
          loaded: true,
        });
      })
      .catch(() => { if (!cancelled) setBrand({ name: "", hasLogo: false, logoUrl: null, loaded: true }); });
    return () => { cancelled = true; };
  }, []);

  return brand;
}
